import api from '@/api/user'
import Auth from '@/utils/Auth.js'

const state = {
    sysToken: localStorage.getItem(Auth.YT_JY_TOKEN) || null
}

const getters = {
    sysToken: state => {
        let type = typeof state.sysToken ;

        return  type === "string" ? JSON.parse(state.sysToken) : state.sysToken
    }
}

const mutations = {
    updateToken(state, token) {
        state.systoken = token
        localStorage.setItem(Auth.YT_JY_TOKEN, token)
    }
}

const actions = {
    // 登录
    async login({ commit }, params) {
        try {
            const res = await api.login(params)
            if (res.data.ErrorCode === 200) {
                commit('updateToken', res.data.Data.sToken)
            }
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 验证码
    async sendCode({ commit }, params) {
        try {
            const res = await api.sendCode(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // register
    async register({ commit }, params) {
        try {
            const res = await api.register(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 修改密码
    async editPass({ commit }, params) {
        try {
            const res = await api.editPass(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 忘记密码
    async forget({ commit }, params) {
        try {
            const res = await api.forget(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 订单详情
    async orderLog({ commit }, params) {
        try {
            const res = await api.log(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 申请试用
    async apply({ commit }, params) {
        try {
            const res = await api.apply(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 价格
    async getDcVipLevel({ commit }, params) {
        try {
            const res = await api.getDcVipLevel(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 立即购买
    async getDcBuy({ commit }, params) {
        try {
            const res = await api.getDcBuy(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },
    // 查询订单
    async getDcQuery({ commit }, params) {
        try {
            const res = await api.getDcQuery(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 修改头像
    async editAvatar({ commit }, params) {
        try {
            const res = await api.editAvatar(params)
            return res
        } catch (errMsg) {
            console.error(errMsg)
        }
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
